export default __webpack_public_path__ + "static/media/who-we-are.f00bda52.jpg";